/**
 * BadgeCard — earned vs locked variants. Hover reveals description.
 */
import { Lock, Trophy, Award, Crown, Star, MapPin, Snowflake, Gem, Camera, Shield } from 'lucide-react';

const ICONS = {
  trophy: Trophy,
  award: Award,
  crown: Crown,
  star: Star,
  'map-pin': MapPin,
  snowflake: Snowflake,
  gem: Gem,
  camera: Camera,
  shield: Shield,
};

const RARITY_STYLES = {
  common: 'from-[#3a3f3a]/40 to-[#1f221f]/40 border-white/10',
  rare: 'from-[#c8b273]/15 to-[#7d6730]/10 border-[#c8b273]/30',
  epic: 'from-[#c8b273]/25 to-[#c8b273]/5 border-[#c8b273]/50',
  legendary: 'from-[#c8b273]/40 to-[#7d6730]/20 border-[#c8b273] shadow-[0_0_20px_rgba(200,178,115,0.2)]',
};

const RARITY_LABEL = {
  common: 'COMMON',
  rare: 'RARE',
  epic: 'EPIC',
  legendary: 'LEGENDARY',
};

const BadgeCard = ({ badge, earned = false }) => {
  const Icon = ICONS[badge.icon] || Trophy;
  return (
    <div
      data-testid={`badge-card-${badge.code}-${earned ? 'earned' : 'locked'}`}
      className={`relative glass-card p-5 text-center bg-gradient-to-br border-2 ${RARITY_STYLES[badge.rarity] || RARITY_STYLES.common} transition-transform hover:scale-[1.02] ${
        !earned ? 'opacity-60' : ''
      }`}
    >
      {/* Rarity badge */}
      <span className="absolute top-2 right-2 text-[9px] font-bold tracking-widest text-[#c8b273]/80">
        {RARITY_LABEL[badge.rarity] || 'COMMON'}
      </span>

      {/* Icon */}
      <div
        className={`mx-auto mb-3 flex h-16 w-16 items-center justify-center rounded-full transition-transform ${
          earned
            ? 'bg-[#c8b273] text-black shadow-[0_0_20px_rgba(200,178,115,0.35)]'
            : 'bg-[#1f221f] text-[#3a3f3a] border border-white/10'
        }`}
      >
        {earned ? <Icon className="h-7 w-7" /> : <Lock className="h-6 w-6" />}
      </div>

      <h4 className="font-['Barlow_Condensed'] text-base font-bold uppercase tracking-wider text-white mb-1">
        {badge.name}
      </h4>
      <p className="text-xs text-[#8a948a] mb-2 line-clamp-2 min-h-[2.5rem]">{badge.description}</p>

      {earned && badge.earned_at && (
        <p className="text-[10px] text-[#c8b273] uppercase tracking-widest">
          Earned {new Date(badge.earned_at).toLocaleDateString('en-GB', { month: 'short', year: 'numeric' })}
        </p>
      )}
      {!earned && <p className="text-[10px] text-[#6b7d6b] uppercase tracking-widest">Locked</p>}
    </div>
  );
};

export default BadgeCard;
